<template>
   <div class="col-md-4" id="time_section">
      <info-box :title="'Program Block Start/End Time'" :height="366">

         <div class="block-box-label time-label">Starts</div>
         <div class="input-container">
            <timepicker type="time" 
               id="block_exp_time"
               :value="startTime"
               @input="$emit('changeStartTime', $event)">
            </timepicker>
         </div>

         <div class="block-box-label time-label">Ends</div>
         <div class="input-container">
            <timepicker type="time" 
               id="block_exp_time"
               :value="endTime"
               @input="$emit('changeEndTime', $event)">
            </timepicker>
         </div>
         
      </info-box>
   </div>

</template>

<script>

export default {
   data() {
      return {
         startTimeDT: new Date(),
         endTimeDT: new Date()
      }
   },

   props: ['startTime', 'endTime', 'reset'],

   methods: {
      // startToTimeString() {
      //    let startTimeStr = this.startTimeDT.getHours() + ":" + this.startTimeDT.getMinutes() + ':01';
      //    this.$emit('changeStartTime', startTimeStr);
      // },

      // endToTimeString() {
      //    let endTimeStr = this.endTimeDT.getHours() + ":" + this.endTimeDT.getMinutes() + ':00';
      //    this.$emit('changeEndTime', endTimeStr);
      // },

      /*
         Need to convert our times to Datetime Objects
      */
      initTimes() {
         // if (this.startTime != '') {
         //    this.startTimeDT.setHours(parseInt(this.startTime.split(':')[0]));
         //    this.startTimeDT.setMinutes(parseInt(this.startTime.split(':')[1]));
         // }
         
         // if (this.endTime != '') {
         //    this.endTimeDT.setHours(parseInt(this.endTime.split(':')[0]));
         //    this.endTimeDT.setMinutes(parseInt(this.endTime.split(':')[1]));
         // } else {
         //    //init end time 1 hour past start time
         //    this.endTimeDT.setHours(this.startTimeDT.getHours() + 1);
         // }

         // this.startToTimeString();
         // this.endToTimeString();
      }
   },

   created() {
      // this.initTimes();
   },

   watch: {
      // startTime() {
      //    this.initTimes();
      // },

      // endTime() {
      //    this.initTimes();
      // },

      // startTimeDT() {
      //    this.startToTimeString();
      // },

      // endTimeDT() {
      //    this.endToTimeString();
      // },

      // reset() {
      //    this.initTimes();
      // }
   }
}
</script>

<style lang="scss" scoped>
#time_section {
   .timepicker .dropdown-content .dropdown-item {
   
      .control {
      
         select {
            font-size: 28px;
            padding: 5px 30px;
         }

         &:last-child {
            select {
               font-size: 20px;
            }
         }
      }
   }
}

.time-label {
   margin-top: 12px;
   margin-bottom: 2px;
}
</style>
